import { cn } from "../../../shared/landing-page/utils";
import "./navigation-menu.scss";

interface NavigationMenuProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
}

export const NavigationMenu: React.FC<NavigationMenuProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <nav
      className={cn("NavigationMenu", className)}
      {...props}
    >
      {children}
    </nav>
  );
};

interface NavigationMenuListProps extends React.HTMLAttributes<HTMLUListElement> {
  children: React.ReactNode;
}

export const NavigationMenuList: React.FC<NavigationMenuListProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <ul
      className={cn("NavigationMenuList", className)}
      {...props}
    >
      {children}
    </ul>
  );
};

interface NavigationMenuItemProps extends React.HTMLAttributes<HTMLLIElement> {
  children: React.ReactNode;
}

export const NavigationMenuItem: React.FC<NavigationMenuItemProps> = ({ children, ...props }) => {
  return <li className="NavigationMenuItem" {...props}>{children}</li>;
};

interface NavigationMenuLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
}

export const NavigationMenuLink: React.FC<NavigationMenuLinkProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <a
      className={cn("NavigationMenuLink", className)}
      {...props}
    >
      {children}
    </a>
  );
};
